import { BaseAnalyticsService } from 'app/services/analytics.services/analytics.service';
import { CurrentUser } from 'app/classes/current.user/current.user';
import { $Constants } from 'app/classes';

export interface IIntercomSettings {
    user_id: string;
    email: string;
    name: string;
    company: {
        id: string;
        name: string;
    };
}

class IntercomService extends BaseAnalyticsService {

    public api;
    public appId;

    public init() {

        if (this.api) {
            return;
        }
        this.appId = $Constants.intercom;

        (window as any).intercomSettings = {
            app_id: this.appId,
            custom_launcher_selector: '#sps-intercom-launcher'
        };

        // This is weird minified Intercom code with a few updates to make it work in Typescript - icky
        // tslint is disabled for the Intercom code below

        /* tslint:disable */
        let intercomSetup = function (appId) {
            var w: any = window;
            var ic = w.Intercom;
            if (typeof ic === "function") {
                ic('reattach_activator');
                ic('update', (<any>window).intercomSettings);
            } else {
                var d = document;
                var i: any = function () {
                    i.c(arguments)
                };
                i.q = [];
                i.c = function (args) {
                    i.q.push(args)
                };
                w.Intercom = i;
                const l = function () {
                    var s = d.createElement('script');
                    s.type = 'text/javascript';
                    s.async = true;
                    s.src = 'https://widget.intercom.io/widget/' + appId;
                    var x = d.getElementsByTagName('script')[0];
                    x.parentNode.insertBefore(s, x);
                }

                if (w.attachEvent) {
                    w.attachEvent('onload', l);
                } else {
                    w.addEventListener('load', l, false);
                }
            }
        };
        /* tslint:enable */

        intercomSetup(this.appId);
        this.api = (...args) => {
            (window as any).Intercom(...args);
        };

    }

    public setUser(user: CurrentUser) {
        const settings: IIntercomSettings = {
            user_id: user.id,
            email: user.email,
            name: `${user.name.first} ${user.name.last}`,
            company: {
                id: user.company.id || '000',
                name: user.company.name || 'no org'
            }
        };

        this.api('update', settings);
    }

    public sendEvent(event: string, metaData?: any) {
        this.api('trackEvent', event, metaData);
    }

    public destroy() {
        this.api('shutdown');
    }

}

export let intercomService = new IntercomService();
